import {
  Box,
  Button,
  Dialog,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode } from 'react';
import './confirmDialog.css';

type ConfirmDialogProps = {
  open?: boolean;
  title?: string;
  message?: string | ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  disableConfirm?: boolean;
  variant?: 'default' | 'delete';
  showCustomBody?: boolean;
  renderCustomBody?: ReactNode;
  disableActions?: boolean;
};

const ConfirmDialog = ({
  open = true,
  title = 'Confirme la acción',
  message = '¿Deseas añadir una nueva institución?',
  cancelLabel = 'Cancelar',
  confirmLabel = 'Confirmar',
  onClose,
  onConfirm,
  onCancel,
  disableConfirm = false,
  variant = 'default',
  showCustomBody = false,
  renderCustomBody,
  disableActions
}: ConfirmDialogProps) => {
  const onConfirmDialog = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onConfirm();
    onClose();
  };

  const getVariantClassName = () => {
    switch (variant) {
      case 'default':
        return 'ConfirmDialog-Button-Default';
      case 'delete':
        return 'ConfirmDialog-Button-Delete';
      default:
        return '';
    }
  };

  return (
    <Dialog
      disableEnforceFocus
      className="ConfirmDialog-Container"
      data-testid='confirm-dialog'
      id="confirm-dialog"
      open={open}
      onClose={onCancel || onClose}
    >
      <Box className="ConfirmDialog-TitleBox">
        <Typography variant="h6" className="ConfirmDialog-Title">
          {title}
        </Typography>
        <Button className="ConfirmDialog-Close" id="ConfirmDialog-Close" onClick={onCancel || onClose}>
          <CloseIcon fontSize="small" />
        </Button>
      </Box>
      <Box className="ConfirmDialog-ContentBox">
        {message}
        {showCustomBody && renderCustomBody}
      </Box>
      {!disableActions && <Box className="ConfirmDialog-ButtonsBox">
        <Button
          className="ConfirmDialog-Button ConfirmDialog-Cancel"
          id="ConfirmDialog-Button-ConfirmDialog-Cancel"
          variant="contained"
          onClick={onCancel || onClose}
        >
          {cancelLabel}
        </Button>
        <Button
          autoFocus
          className={`ConfirmDialog-Button ${getVariantClassName()}`}
          id="ConfirmDialog-Button "
          variant="contained"
          onClick={(e) => onConfirmDialog(e)}
          disabled={disableConfirm}
        >
          {confirmLabel}
        </Button>
      </Box>
      }
    </Dialog>
  );
};

export default ConfirmDialog;
